import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons'
import { List, Text, Title, Anchor, Card, Divider, Flex } from '@mantine/core'

import { useTranslation, Trans } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import { useInsuranceTermsAndConditionsURL, useIntercom } from '@flecto/utils'

export function CardInsuranceTerms() {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })
  const { showIntercomWithMessage } = useIntercom()
  const insuranceTermsAndConditionsURL = useInsuranceTermsAndConditionsURL()

  const terms = [
    t('zero_deductible_coverage'),
    t('booking_fee_charge'),
    t('insurance_charged_only_when_activated'),
    t('coverage_limit_per_item'),
    t('items_not_covered'),
    t('claim_submission_deadline'),
  ]

  return (
    <Card withBorder mt='lg'>
      <Title order={5} mb='md'>
        {t('our_terms')}
      </Title>
      <Text>{t('terms_description')}</Text>
      <List m='md'>
        {terms.map((term, key) => (
          <List.Item key={key}>{term}</List.Item>
        ))}
      </List>

      <Text mb='lg'>
        <Trans
          ns='saas'
          i18nKey='insurances.terms_and_conditions'
          components={{
            a: (
              <Anchor
                href={insuranceTermsAndConditionsURL}
                target='_blank'
                rel='noreferrer'
              />
            ),
          }}
        />
      </Text>

      <Card.Section>
        <Divider color='gray.2' />
      </Card.Section>

      <Flex pt='md' gap='sm' align='baseline'>
        <Icon icon={faCircleQuestion} color='gray.7' />
        <Text color='gray.7'>
          {t('insurance_infos')}{' '}
          <Anchor
            component='button'
            onClick={() => showIntercomWithMessage('')}
            fw={500}
          >
            {t('insurance_contact')}
          </Anchor>
        </Text>
      </Flex>
    </Card>
  )
}
